import type { PluginSimple } from 'markdown-it';

export const underlinePlugin: PluginSimple = (md) => {
  md.inline.ruler.after('emphasis', 'underline', (state, silent) => {
    const match = /^__([^_]+)__/g.exec(state.src.slice(state.pos));
    if (!match) return false;
    if (silent) return false;

    // Añadir el token para underline
    const token = state.push('underline_open', 'u', 1);
    token.markup = '__';
    token.content = match[1];

    state.pos += match[0].length;

    const closeToken = state.push('underline_close', 'u', -1);
    closeToken.markup = '__';

    return true;
  });
};
